import { Handle, Position } from "@xyflow/react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import AddEditProductModal from "./AddEditProductModal";

const ViewProductBox = ({
  data,
  onNewStep,
  totalSteps,
  onDelete,
  steps = [],
  onEditContent,
}) => {
  const { part, branchOption } = data || [];
  const product = part?.product || [];
  const [showProductAddEditPopup, setShowProductAddEditPopup] = useState(false);

  const handleAddEditProduct = () => {
    setShowProductAddEditPopup(true);
  };

  return (
    <div
      className={
        !branchOption && data?.stepIndex + 1 === totalSteps
          ? "last-step view-poll-box"
          : "view-poll-box"
      }
    >
      <Handle type="target" position={Position.Top} id="top-handle" />
      <Handle type="target" position={Position.Left} id="left-handle" />

      <div
        style={{
          marginRight: "0px",
          backgroundColor: "transparent",
          display: "flex",
          gap: "50px",
        }}
        key={product.id}
      >
        <div style={{ width: "350px" }}>
          {branchOption ? (
            <>
              <div className="user-option-selected-container">
                <div className="user-option-header">If user select</div>
                <span
                  className="remove-button"
                  onClick={() => onDelete(data.branchId, "branch")}
                >
                  Remove
                </span>
              </div>
              <div className="option-container">{branchOption}</div>
            </>
          ) : (
            <div className="step-number">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">Step {data.order}</span>
                <span
                  className="customLabel remove-button"
                  onClick={() => handleAddEditProduct()}
                >
                  Edit
                </span>
                <span
                  className="customLabel remove-button"
                  onClick={() => onDelete(data.id, "step")}
                >
                  Remove
                </span>
              </div>
            </div>
          )}
          <div
            className="form-box"
            style={{ backgroundColor: product.styleBackground.color }}
          >
            {product.productImage != null && (
              <div className="form-box-image">
                <img
                  src={
                    product.productImage.startsWith("http://") ||
                    product.productImage.startsWith("https://")
                      ? product.productImage
                      : `https://cdn.sided.co/${product.productImage}`
                  }
                  alt="content"
                />
              </div>
            )}
            <div
              className="form-box-title"
              style={{
                color: product?.styleTitle?.color,
                fontSize: product?.styleTitle?.fontSize,
                //-- styling for text wrap
                overflow: "hidden",
                Overflow: "ellipsis",
                eSpace: "nowrap",
                maxWidth: "100%",
              }}
            >
              {product.title}
            </div>
            <div
              className="form-box-description"
              style={{
                color: product?.styleDescription?.color,
                fontSize: product?.styleDescription?.fontSize,
                //-- styling for text wrap
                overflow: "hidden",
                Overflow: "ellipsis",
                eSpace: "nowrap",
                maxWidth: "100%",
                fontWeight: 400,
              }}
            >
              {product.description}
            </div>
            <div
              className="form-box-description"
              style={{
                color: product?.stylePrice?.color,
                fontSize: product?.stylePrice?.fontSize,
              }}
            >
              $ {product.price}
            </div>

            <button
              disabled
              className="form-box-submit blue-button"
              style={{
                backgroundColor: product?.styleButton?.color, // Text color
                fontSize: product?.styleButton?.fontSize,
                color: product?.styleButton?.textColor,
              }}
            >
              {product.buttonText || "Submit"}
            </button>
            
            {product?.styleCouponButton?.copyValue.trim() !== "" && (
              <span
                className="form-box-submit blue-button"
                style={{
                  backgroundColor: product?.styleCouponButton?.color, // Text color
                  fontSize: product?.styleCouponButton?.fontSize,
                  color: product?.styleCouponButton?.textColor,
                  fontWeight: "normal",
                  borderRadius: "9999px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {product.couponButtonText || "Copy Coupon Code"}
              </span>
            )}
            
          </div>
          {showProductAddEditPopup && (
            <AddEditProductModal
              show={showProductAddEditPopup}
              onClose={() => {
                setShowProductAddEditPopup();
                onEditContent(true);
              }}
              productId={product.id}
              // sequenceId={sequenceId}
              // orderNumber={orderNumber}
              // match={{ params: { id: "new" } }}
              // selNetworkId={selNetworkId}
            />
          )}
        </div>
        {!branchOption && data?.stepIndex + 1 === totalSteps && (
          <div>
            <div className="add-step-button-container">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">
                  Add Step {data.order + 1}
                </span>
              </div>
            </div>
            <div className="add-step-branch-group">
              <div className="d-flex justify-content-center border align-items-center add-step-container">
                <Button
                  onClick={() => onNewStep(data)}
                  className="add-step-button"
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="bottom-handle" />
      <Handle type="source" position={Position.Right} id="right-handle" />
    </div>
  );
};

export default ViewProductBox;
